"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UICardWrapper = _interopRequireDefault(require("UIComponents/card/UICardWrapper"));

var _colors = require("HubStyleTokens/colors");

var _responsiveBreakpoints = _interopRequireDefault(require("pricing-pages-unified-ui/utils/responsiveBreakpoints"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H4"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _PriceDisplay = _interopRequireDefault(require("../../common/pricing/PriceDisplay"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _ChecklistItem = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/ChecklistItem"));

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    width: 100%;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    margin: auto;\n    margin-top: 30px;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    &:not(:last-child) {\n      &:after {\n        display: none;\n      }\n    }\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    flex-direction: column;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    &&& {\n      width: 100%;\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    min-width: 0;\n    &&& {\n      width: 90%;\n      margin: 0 auto;\n    }\n    > div {\n      flex-direction: column;\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledCardWrapper = (0, _styledComponents.default)(_UICardWrapper.default).withConfig({
  displayName: "BundleCard__StyledCardWrapper",
  componentId: "sc-1ftisne-0"
})(["border:1px solid ", ";background-color:", ";min-height:300px;text-align:left;", ";", ";"], _colors.BATTLESHIP, _colors.OLAF, _responsiveBreakpoints.default.tablet(_templateObject()), _responsiveBreakpoints.default.phone(_templateObject2()));

var ContentContainer = _styledComponents.default.div.withConfig({
  displayName: "BundleCard__ContentContainer",
  componentId: "sc-1ftisne-1"
})(["padding:30px 40px;display:flex;justify-content:space-between;", ""], _responsiveBreakpoints.default.tablet(_templateObject3()));

var CostPrice = (0, _styledComponents.default)(_PriceDisplay.default).withConfig({
  displayName: "BundleCard__CostPrice",
  componentId: "sc-1ftisne-2"
})(["font-size:38px;font-weight:bold;color:", ";"], function (_ref) {
  var hasDiscount = _ref.hasDiscount;
  return hasDiscount ? _colors.OZ : _colors.OBSIDIAN;
});
var PerMonthSubtext = (0, _styledComponents.default)(_FormattedMessage.default).withConfig({
  displayName: "BundleCard__PerMonthSubtext",
  componentId: "sc-1ftisne-3"
})(["font-size:26px;font-weight:600;color:", ";"], function (_ref2) {
  var hasDiscount = _ref2.hasDiscount;
  return hasDiscount ? _colors.OZ : _colors.OBSIDIAN;
});

var ListPriceSpan = _styledComponents.default.span.withConfig({
  displayName: "BundleCard__ListPriceSpan",
  componentId: "sc-1ftisne-4"
})(["font-size:18px;font-weight:400;text-decoration:line-through;"]);

var Subtext = _styledComponents.default.span.withConfig({
  displayName: "BundleCard__Subtext",
  componentId: "sc-1ftisne-5"
})(["font-size:12px;color:", ";"], _colors.SLINKY);

var InlineListItem = _styledComponents.default.div.withConfig({
  displayName: "BundleCard__InlineListItem",
  componentId: "sc-1ftisne-6"
})(["display:flex;align-items:center;&:not(:last-child){margin-right:16px;&::after{margin-left:20px;font-weight:normal;color:", ";content:'|';}}", ";"], _colors.BATTLESHIP, _responsiveBreakpoints.default.phone(_templateObject4()));

var CTAsContainer = _styledComponents.default.div.withConfig({
  displayName: "BundleCard__CTAsContainer",
  componentId: "sc-1ftisne-7"
})(["width:200px;text-align:center;button,a{width:100%;line-height:25px;}", " ", ""], _responsiveBreakpoints.default.tablet(_templateObject5()), _responsiveBreakpoints.default.phoneLarge(_templateObject6()));

var Bold = _styledComponents.default.div.withConfig({
  displayName: "BundleCard__Bold",
  componentId: "sc-1ftisne-8"
})(["font-weight:600;margin-top:12px;"]);

var IncludedMerch = function IncludedMerch(_ref3) {
  var iconSrc = _ref3.iconSrc,
      message = _ref3.message;
  return _react.default.createElement(InlineListItem, null, _react.default.createElement(_UIImage.default, {
    className: "display-inline m-right-2",
    height: 13,
    width: 13,
    src: iconSrc,
    responsive: false
  }), _react.default.createElement("b", null, _react.default.createElement(_FormattedMessage.default, {
    message: message
  })));
};

var BundleCard = function BundleCard(_ref4) {
  var banner = _ref4.banner,
      title = _ref4.title,
      listPrice = _ref4.listPrice,
      costPrice = _ref4.costPrice,
      currencyCode = _ref4.currencyCode,
      _ref4$descriptionSubt = _ref4.descriptionSubtext,
      descriptionSubtext = _ref4$descriptionSubt === void 0 ? null : _ref4$descriptionSubt,
      _ref4$bizObjectives = _ref4.bizObjectives,
      bizObjectives = _ref4$bizObjectives === void 0 ? [] : _ref4$bizObjectives,
      _ref4$includedMerch = _ref4.includedMerch,
      includedMerch = _ref4$includedMerch === void 0 ? [] : _ref4$includedMerch,
      _ref4$ctasComponent = _ref4.ctasComponent,
      ctasComponent = _ref4$ctasComponent === void 0 ? null : _ref4$ctasComponent;
  var hasDiscount = costPrice < listPrice;
  return _react.default.createElement(StyledCardWrapper, null, banner, _react.default.createElement(ContentContainer, null, _react.default.createElement("div", {
    style: {
      maxWidth: '800px'
    }
  }, _react.default.createElement(_H.default, null, title), _react.default.createElement("p", null, descriptionSubtext), _react.default.createElement(Subtext, null, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.pages.growthSuite.startsAt"
  })), _react.default.createElement(Bold, null, _react.default.createElement(CostPrice, {
    hasDiscount: hasDiscount,
    price: costPrice,
    currencyCode: currencyCode
  }), _react.default.createElement(PerMonthSubtext, {
    hasDiscount: hasDiscount,
    message: "pricingPage.calculator.priceDisplay.perMonth"
  }), hasDiscount && _react.default.createElement(ListPriceSpan, {
    className: "m-left-2"
  }, _react.default.createElement(_PriceDisplay.default, {
    price: listPrice,
    currencyCode: currencyCode
  }), _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.calculator.priceDisplay.perMonth"
  }))), _react.default.createElement(Bold, {
    className: "m-bottom-1"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "recommendedBundles.idealFor"
  })), bizObjectives.map(function (bizObjectiveText) {
    return _react.default.createElement(_ChecklistItem.default, {
      key: bizObjectiveText,
      message: bizObjectiveText
    });
  }), _react.default.createElement(Bold, null, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.pages.growthSuite.includes"
  })), _react.default.createElement(_UIFlex.default, {
    wrap: "wrap"
  }, includedMerch.map(function (merchConfig, i) {
    return _react.default.createElement(IncludedMerch, Object.assign({
      key: i
    }, merchConfig));
  }))), _react.default.createElement(CTAsContainer, null, ctasComponent)));
};

var _default = BundleCard;
exports.default = _default;
module.exports = exports.default;